import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PaginationControls({
  children,
  isEmpty,
  pagination
}) {
  const handlePageChange = event => {
    if (!pagination.loading) {
      pagination.onPageChange(event.target.value);
    }
  };
  const showPagination = pagination.hasMore || pagination.currentPage > 1;
  if (pagination.loading && isEmpty && pagination.currentPage === 1) {
    return /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "common.loading"
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, showPagination && /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      columnGap: "400",
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(Paginator, {
        page: pagination.currentPage,
        pageCount: pagination.pageCount,
        maxVisiblePageButtons: 0,
        onPageChange: handlePageChange,
        showButtonLabels: true
      })
    })]
  });
}